import proj4 from 'proj4';

proj4.defs('LOCAL_TANGENT_PLANE', '+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs');

export function createLocalProjection(centerLng, centerLat) {
  const origin = [centerLng, centerLat];
  const localDef = `+proj=tmerc +lat_0=${centerLat} +lon_0=${centerLng} +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs`;
  proj4.defs('LOCAL_TANGENT_PLANE', localDef);
  return {
    forward: (lng, lat) => {
      const [x, y] = proj4('LOCAL_TANGENT_PLANE', [lng, lat]);
      return { x, y };
    },
    inverse: (x, y) => {
      const [lng, lat] = proj4('LOCAL_TANGENT_PLANE', 'WGS84', [x, y]);
      return { lng, lat };
    },
    origin,
  };
}

export function computeCentroid(coords) {
  if (!coords || coords.length === 0) return null;
  const lngSum = coords.reduce((s, c) => s + c[0], 0);
  const latSum = coords.reduce((s, c) => s + c[1], 0);
  return [lngSum / coords.length, latSum / coords.length];
}

export function makeLocalProjector(refLat, refLng) {
  const proj = createLocalProjection(refLng, refLat);
  return (lat, lng) => proj.forward(lng, lat);
}
